export const STORAGE_KEY = {
  TOKEN: 'token',
  SUBSCRIPTION_ID: 'subscription_id',
  DATA: 'data',
  PROMO_CODE: 'promo_code',
  EXIT_DISCOUNT_MODAL: 'exit_discount_modal',
  APPLY_DISCOUNT: 'apply_discount',
  ROLE: '_attmp',
  CHUNK_RELOAD: 'chunk-reload-at',
};
